import httpRequest from 'httpRequest'
import {
    PaymentSettingContract,
    SaleContract,
    PaymentReceiptReportNotificationContract,
    ProcessPaymentContract,
    SaleSlimModel,
    GiftCardSaleProcessContract,
    GiftCardSaleContract,
    GiftCardSaleTopupProcessContract,
    GiftCardPaymentReceiptEmailContract,
    PaymentResultContract,
} from 'models'
import { processOfflinePayment } from './offline/payment.service.offline'

const PAYMENT_PREFIX = '/location/payments'

const paymentService = {
    getPreviewReceipt: (orderID: string) =>
        httpRequest.get<PaymentSettingContract[]>(
            `${PAYMENT_PREFIX}/preview-receipt/${orderID}`,
        ),
    processPayment: (receipt: ProcessPaymentContract, isOffline?: boolean) => {
        if (isOffline) {
            return processOfflinePayment(receipt)
        } else {
            return httpRequest.post<SaleSlimModel>(
                `${PAYMENT_PREFIX}/process`,
                receipt,
            )
        }
    },
    sendPaymentReceiptReport: (
        paymentReceiptReport: PaymentReceiptReportNotificationContract,
    ) => {
        return httpRequest.post<SaleContract>(
            `${PAYMENT_PREFIX}/email/report-receipt`,
            paymentReceiptReport,
        )
    },
    sendGiftCardIssues: (
        giftcardPaymentDetail: GiftCardPaymentReceiptEmailContract,
    ) => {
        return httpRequest.post<SaleContract>(
            `${PAYMENT_PREFIX}/email/giftcards`,
            giftcardPaymentDetail,
        )
    },
    saleGiftCard: (payload: GiftCardSaleProcessContract) => {
        return httpRequest.post<GiftCardSaleContract>(
            `${PAYMENT_PREFIX}/gift-card/sale`,
            payload,
        )
    },
    topUpGiftCard: (payload: GiftCardSaleTopupProcessContract) => {
        return httpRequest.post<GiftCardSaleContract>(
            `${PAYMENT_PREFIX}/gift-card/topup`,
            payload,
        )
    },
    checkPaymentIntegrationStatus: (transactionId: string) => {
        return httpRequest.get<PaymentResultContract>(
            `${PAYMENT_PREFIX}/status/${transactionId}`,
        )
    },
    voidTransaction: (payload: {
        paymentIntegrationActivityID: string
        pinCode?: string
    }) => {
        return httpRequest.post<string>(
            `${PAYMENT_PREFIX}/void-payment-integration/${payload.paymentIntegrationActivityID}`,
            payload,
        )
    },
    voidPayment: (payload: { paymentID: string; pinCode?: string }) => {
        return httpRequest.post<string>(
            `${PAYMENT_PREFIX}/${payload.paymentID}/void`,
            payload,
        )
    },
}

export default paymentService
